export const permissions = [
  [true, true, true, true],
  [true, true, false, true],
  [true, true, false, true],
  [true, true, false, false],
  [true, true, false, false],
  [true, false, false, false],
  [true, false, false, false],
];
